import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'

interface Props {
  type: ComponentProgressDetailView['type']
}

export function PartialDataFallback({ type }: Props) {
  const { t } = useTranslation('coaching')
  return (
    <div className="rounded-lg bg-amber-50 border border-amber-200 p-6 text-center text-sm text-amber-700">
      {t('fallback.partialData', { type })}
    </div>
  )
}
